import React, {useCallback, useEffect, useState} from "react";
import * as Sentry from "@sentry/react";

function Recaptcha({ setScriptLoaded, recaptchaRef, actionName }) {
  const [scriptInitialized, setScriptInitialized] = useState(false)
  const recaptchaSiteKey = window.config.FULFILLMENT_RECAPTCHA_ENTERPRISE_SITE_KEY
  const recaptchaUrl = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaSiteKey}`

  const loadScript = useCallback(async () => {
    setScriptLoaded();
  }, [setScriptLoaded])

  const handleLoadErrorEvent = useCallback((event) => {
    Sentry.captureException(event.error);
  }, [])

  const getRecaptchaToken = useCallback(async () => {
    await new Promise((resolve) => window.grecaptcha.enterprise.ready(resolve));
    return window.grecaptcha.enterprise.execute(recaptchaSiteKey, {
      action: actionName,
    });
  }, [actionName, recaptchaSiteKey]);

  useEffect(() => {
    // Ensure there is no case where we inadvertently load the script twice
    if (scriptInitialized) {
      return;
    }
    setScriptInitialized(true)

    const script = document.createElement("script")
    script.src = recaptchaUrl
    script.addEventListener("load", loadScript)
    script.addEventListener("error", handleLoadErrorEvent)
    document.body.appendChild(script)
    recaptchaRef.current = getRecaptchaToken
  }, [scriptInitialized, recaptchaRef, getRecaptchaToken, setScriptInitialized, loadScript, handleLoadErrorEvent, recaptchaUrl])

    return (
        <div className="g-recaptcha" data-sitekey={recaptchaSiteKey} data-size="invisible" />
    )
}

export default Recaptcha;